<div class="quiz-question p-4" [class.rtl]="isRTL" [class.disabled]="disabled">
  <!-- Question Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="d-flex align-items-center gap-2">
      <h5 class="fs-16 fg-600 text-color mb-0">
        {{ questionLabel | translate }} {{ questionNumber }} / {{ totalQuestions }}
      </h5>
      <span class="badge" [ngClass]="getQuestionTypeBadgeClass()">
        {{ getQuestionTypeBadgeText() | translate }}
      </span>
    </div>
    <div *ngIf="showPoints && points > 0" class="badge bg-primary">
      <i class="fas fa-star me-1"></i>
      {{ points }} {{ 'QUIZ.POINTS' | translate }}
    </div>
  </div>

  <!-- Question Title -->
  <div class="question-title mb-3">
    <h4 class="fs-18 fg-500 text-color mb-0"><app-math-text [text]="title"></app-math-text></h4>
  </div>

  <!-- Question Content/Description -->
  <div class="question-content mb-4" *ngIf="content">
    <p class="fs-14 text-muted mb-0"><app-math-text [text]="content"></app-math-text></p>
  </div>

  <!-- Selection Instructions -->
  <div class="selection-hint mb-3" *ngIf="isMultipleChoice && !disabled">
    <small class="text-info">
      <i class="fas fa-info-circle me-1"></i>
      {{ 'QUIZ.SELECT_MULTIPLE_HINT' | translate }}
    </small>
  </div>

  <!-- Answers List -->
  <div class="answers-list">
    <div *ngFor="let answer of answers; let i = index" class="answer-option mb-3 p-3 border rounded transition-all"
      [class.selected]="isSelected(answer.id)" [class.answer-selected]="isSelected(answer.id)"
      [class.answer-hover]="!isSelected(answer.id) && !disabled" [class.answer-disabled]="disabled"
      (click)="selectAnswer(answer.id)" [attr.role]="disabled ? 'presentation' : 'button'"
      [attr.tabindex]="disabled ? -1 : 0" [attr.aria-disabled]="disabled" (keydown.enter)="selectAnswer(answer.id)"
      (keydown.space)="selectAnswer(answer.id, $event)">
      <div class="d-flex align-items-start gap-3">
        <!-- Answer Label (A, B, C, D) -->
        <div class="answer-label">
          <span class="badge badge-answer" [class.bg-primary]="isSelected(answer.id) && !disabled"
            [class.bg-secondary]="!isSelected(answer.id) || disabled">
            {{ getAnswerLabel(i) }}
          </span>
        </div>

        <!-- Checkbox/Radio Input -->
        <div class="form-check">
          <input class="form-check-input" [class.cursor-pointer]="!disabled"
            [type]="isMultipleChoice ? 'checkbox' : 'radio'" [name]="'question-' + questionNumber"
            [id]="'answer-' + answer.id" [checked]="isSelected(answer.id)" [disabled]="disabled"
            (change)="selectAnswer(answer.id, $event)" (click)="$event.stopPropagation()" />
        </div>

        <!-- Answer Content -->
        <label class="form-check-label flex-grow-1 mb-0" [class.cursor-pointer]="!disabled"
          [class.text-muted]="disabled" [for]="'answer-' + answer.id" (click)="$event.preventDefault()">
          <span class="fs-14 d-block"><app-math-text [text]="answer.content"></app-math-text></span>
        </label>

        <!-- Selected Indicator -->
        <div class="selected-indicator" *ngIf="isSelected(answer.id) && !disabled">
          <i class="fas fa-check-circle text-primary fs-5"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- No answers available message -->
  <div *ngIf="!answers || answers.length === 0" class="alert alert-warning" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ 'QUIZ.NO_ANSWERS_AVAILABLE' | translate }}
  </div>

  <!-- Answer Count (for multiple choice) -->
  <div class="answer-count mt-3" *ngIf="isMultipleChoice && selectedAnswers.length > 0 && !disabled">
    <small class="text-primary fw-bold">
      <i class="fas fa-check-square me-1"></i>
      {{ selectedAnswers.length }} {{ 'QUIZ.ANSWERS_SELECTED' | translate }}
    </small>
  </div>

  <!-- Disabled state message -->
  <div class="mt-3" *ngIf="disabled">
    <div class="alert alert-secondary d-flex align-items-center" role="alert">
      <i class="fas fa-lock me-2"></i>
      <span>{{ 'TESTS.QUESTION_LOCKED_MESSAGE' | translate }}</span>
    </div>
  </div>
</div>